import React, { useState, useMemo, useCallback } from 'react'

import { Drawer } from 'antd'

import ContactPersonSections from '../../institution/ContactPersonSections'
import { getSchoolSchoolSections } from '../../../utils/api/school'
import { selectUser } from '../../../reducers/UserReducer'
import useRequest from '../../../hooks/useRequest'
import { getEntityOrNull, getIdOrNull } from '../../../utils'
import { isHospitalAdmin } from '../../../utils/roles'
import { useSelector } from 'react-redux'
import SchoolSectionsTable from './SchoolSectionsTable'
import { TableParameters } from '../../../utils/entities/tableParameters'
import { OrderBy, OrderDirections } from '../../../utils/constants'
import SchoolSectionModal from '../../../Providers/Forms/SchoolSectionModal'

const SchoolSections = ({ school, onClose }) => {
  const user = useSelector(selectUser)

  const [selectedContactPersonSection, setSelectedContactPersonSection] = useState(null)
  const [tableParameters, setTableParameters] = useState(new TableParameters({ order: { by: OrderBy.NAME, direction: OrderDirections.ASC }, pageSize: 20 }))

  const readOnly = useMemo(() => school?.premium || !isHospitalAdmin(user), [school, user])

  const schoolSections = useRequest({
    request: getSchoolSchoolSections,
    parameters: useMemo(() => [getEntityOrNull(school), { order: tableParameters.order }], [school, tableParameters.order]),
    enabled: getIdOrNull(school),
    select: useCallback(data => data[school.id] ?? [], [school])
  })

  return (
    <Drawer
      title={school !== null ? school.name : ''}
      width='80%'
      onClose={onClose}
      visible={school !== null}
    >
      <SchoolSectionModal school={school}>
        <SchoolSectionsTable
          loading={schoolSections.loading}
          data={schoolSections.data}
          parameters={tableParameters}
          readOnly={readOnly}
          metadata={schoolSections.metadata}
          onCreate={() => schoolSections.reload()}
          onParametersChange={setTableParameters}
        />
      </SchoolSectionModal>
      <ContactPersonSections
        section={selectedContactPersonSection}
        onClose={() => setSelectedContactPersonSection(null)}
      />
    </Drawer>
  )
}

export default SchoolSections
